import React from 'react';
import { Link } from '@rcg/ui-react/lib/components';
import { useGlobal } from '@rcg/ui-react';
import { BRAND } from '../../utils/constants';
import useStyles from './useStyles';
import Dictionary from '../../utils/dictionary';
import useDictionary from '../../hooks/useDictionary';
import getBrand from '../../utils/getBrand';
import { appendGlobalizationToPath } from '../../utils/common';

const QuestionsUnified = () => {
  const { data: globalData } = useGlobal();
  const classes = useStyles();
  const getDictionary = useDictionary(Dictionary);
  const isCelebrity = getBrand()?.id === BRAND.CELEBRITY;
  const faqPathUrl = getDictionary(Dictionary.airFlightBookFlightsQuestionsFaqLearnMoreLink.key);
  const faqHrefUrl = appendGlobalizationToPath(faqPathUrl, globalData);
  const faqLearnMorePathUrl = getDictionary(
    Dictionary.airFlightBookFlightsQuestionsLearnMoreLink.key,
  );
  const learnMoreHrefUrl = appendGlobalizationToPath(faqLearnMorePathUrl, globalData);

  return isCelebrity ? (
    <div className={classes.questionsCel}>
      <p>
        {getDictionary(Dictionary.airBookFlightQuestionTextCel.key)}{' '}
        {getDictionary(Dictionary.airFlightBookFlightsQuestionsFaqLearnMore.key) === '_' ? null : (
          <Link target="_blank" href={faqHrefUrl}>
            {getDictionary(Dictionary.airFlightBookFlightsQuestionsFaqLearnMore.key)}
          </Link>
        )}
      </p>
    </div>
  ) : (
    <div className={classes.questions}>
      <div className={classes.questionSectionWrapper}>
        <div className={classes.questionText}>
          <span>{getDictionary(Dictionary.airFlightBookFlightsQuestionsTitle.key)}</span>
          <p className={classes.firstParagraph}>
            {getDictionary(Dictionary.airFlightBookFlightsQuestionsSubTitle.key)}{' '}
            {getDictionary(Dictionary.airFlightBookFlightsQuestionsLearnMore.key) === '_' ? null : (
              <Link target="_blank" href={learnMoreHrefUrl}>
                {getDictionary(Dictionary.airFlightBookFlightsQuestionsLearnMore.key)}
              </Link>
            )}
          </p>
          <p>
            {getDictionary(Dictionary.airFlightBookFlightsQuestionsFaqText.key)}{' '}
            {getDictionary(Dictionary.airFlightBookFlightsQuestionsFaqLearnMore.key) ===
            '_' ? null : (
              <Link target="_blank" href={faqHrefUrl}>
                {getDictionary(Dictionary.airFlightBookFlightsQuestionsFaqLearnMore.key)}
              </Link>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default QuestionsUnified;
